import { gestionSections } from './gestionSections';

export const gestionManual = {
  id: 'mod-gestion',
  title: 'Gestión',
  isVisible: (ctx) => ctx.limitedScope.showGestion,
  intro:
    'Catálogo maestro: clasificación, entidades, productos, servicios, relación SUNAT y parámetros de configuración. Cada función del menú está documentada con la plantilla de 12 apartados.',
  sections: gestionSections,
};
